export const TRAJET_REPORT = `TRAJET_REPORT`;

export const GET_TRAJET_REPORT_LEAD_DATA = `${TRAJET_REPORT}/GET_TRAJET_REPORT_LEAD_DATA`;
export const SET_TRAJET_REPORT_LEAD_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_LEAD_DATA`;

export const GET_TRAJET_REPORT_TEAM_DATA = `${TRAJET_REPORT}/GET_TRAJET_REPORT_TEAM_DATA`;
export const SET_TRAJET_REPORT_TEAM_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_TEAM_DATA`;

export const GET_TRAJET_REPORT_FUNNEL_CHART_DATA = `${TRAJET_REPORT}/GET_TRAJET_REPORT_FUNNEL_CHART_DATA`;
export const SET_TRAJET_REPORT_FUNNEL_CHART_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_FUNNEL_CHART_DATA`;

export const GET_TRAJET_REPORT_LEAD_DETAIL_DATA = `${TRAJET_REPORT}/GET_TRAJET_REPORT_LEAD_DETAIL_DATA`;
export const SET_TRAJET_REPORT_LEAD_DETAIL_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_LEAD_DETAIL_DATA`;

export const GET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA = `${TRAJET_REPORT}/GET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA`;
export const SET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA`;

export const GET_TRAJET_REPORT_LOV_DATA = `${TRAJET_REPORT}/GET_TRAJET_REPORT_LOV_DATA`;
export const SET_TRAJET_REPORT_LOV_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_LOV_DATA`;

export const SET_TRAJET_REPORT_BREADCRUMB_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_BREADCRUMB_DATA`;
export const SET_TRAJET_REPORT_TEAM_LEAD_ASSIGNED_DATA = `${TRAJET_REPORT}/SET_TRAJET_REPORT_TEAM_LEAD_ASSIGNED_DATA`;
